//
//
//
//
//
//
//
//
//
//
//
//
import BmOverlay from 'vue-baidu-map/components/overlays/Overlay';
export default {
  props: ['text', 'position', 'active'],
  watch: {
    position: {
      handler: function handler() {
        if (this.$refs && this.$refs.customOverlay) {
          this.$refs.customOverlay.reload();
        }
      },
      deep: true
    }
  },
  components: {
    BmOverlay: BmOverlay
  },
  methods: {
    handleClick: function handleClick() {
      global.alert('Well done.');
    },
    draw: function draw(_ref) {
      var el = _ref.el,
          BMap = _ref.BMap,
          map = _ref.map;
      var _this$position = this.position,
          lng = _this$position.lng,
          lat = _this$position.lat;
      var pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat));
      el.style.left = pixel.x - 60 + 'px';
      el.style.top = pixel.y - 20 + 'px';
    }
  }
};